import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-dialog-info-polizza-assicurativa',
  templateUrl: './dialog-info-polizza-assicurativa.component.html',
  styleUrls: ['./dialog-info-polizza-assicurativa.component.css']
})
export class DialogInfoPolizzaAssicurativa {

  constructor(public dialogRef: MatDialogRef<DialogInfoPolizzaAssicurativa>) { }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-info-polizza-assicurativa/dialog-info-polizza-assicurativa.component.ts